export enum LayoutKeys {
  Time = 'Time',
  Map = 'Map',
  WeatherCurrent = 'WeatherCurrent',
  WeatherWeek = 'WeatherWeek',
}

export enum HomeViewMode {
  View = 'view',
  Edit = 'edit',
}
